import {
  getStationAudioAdsStatus,
  updateStationAudioAdsStatus,
} from "@/services/StationService";

export const fetchAudioAdsStatus = async ({ commit }, stationKey) => {
  const response = await getStationAudioAdsStatus(stationKey);

  commit("setAudioAdsSettings", response);
};

export const updateAudioAdsStatus = async (
  { commit },
  { stationKey, hasAudioAds, applyToRelays }
) => {
  const response = await updateStationAudioAdsStatus(
    stationKey,
    hasAudioAds,
    applyToRelays
  );

  commit("setAudioAdsSettings", response);
};
